<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.tituloCardListar" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-12 mb-2">
      Una vez que seleccione la planta ya no podrás cambiar de planta. Para cambiar de planta deberas actualizar esta página.
      <div class="pagetitle">
        <div class="btn-group-justified btn-group">
          <button (click)="cambiarPlanta()" class="btn btn-success">
            <i class="fa fa-industry"></i> Cambiar de planta
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <ng-template #enviarTemplateEdit>
    <hr>
    <div class="container mt-3">
      <div class="row">
        <!-- OPCIONES LATERAL IZQUIERDO -->
        <div class="col-4">
          <h6>Seleccione Línea para captura</h6>
          <div *ngIf="plantaSelected">
            <span class="badge bg-warning text-dark p-3">Planta Actual : {{ plantaSelected.plantaId }} - {{ plantaSelected.nombre }}</span>
            <div class="list-group" >
                <button *ngFor="let linea of listLineas" 
                type="button"
                class="list-group-item list-group-item-info text-start"
                [class.active]="linea === lineaSelected"
                (click)="selecionLinea(linea)"> 
                <i class="fa fa-cubes"></i> {{ linea.id }} - {{ linea.nombre }}
                </button>
            </div>
          </div>
        </div>
        <!-- END -->

        <!-- FORMULARIO EN LATERAL DERECHO           <h6>LINEA SELECCIONADA</h6>-->
        <div class="col-8" *ngIf="lineaSelected">

          <app-lfsa-card [innTemplate]="detalleLinea" [titulo]="lineaSelected.nombre"></app-lfsa-card>
          <ng-template #detalleLinea>
            <!-- REPETIR EN CLICLO CADAS 2 COLUMNAS POR N ELEMENTOS -->
            <div class="row font-card">
                <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
                  <div class="col-md-6" *ngFor="let detalle of detalleEvento; let i = index">
                    <b>{{ detalle.etiqueta }}: </b> {{ detalle.valor }}
                  </div>
            </div>
          </ng-template>

            <div class="container-fluid text-center">
              <h6>PESO</h6>
              <h1 class="text-center display-1">{{ valorCaptura }}</h1>
                <form [formGroup]="formCaptura" class="row mt-3">
                  <div class="form-group form-control-sm col-md-3">
                    <label for="control">Pesaje</label>
                    <input class="form-control" formControlName="pesaje" id="pesaje"  name="pesaje" type="number" readonly/>
                  </div>
                  <div class="form-group form-control-sm col-md-3">
                    <app-lfsa-combo-box [opcion]="'nombre'" [idOpcion]="'plantaId'" [comboBox]="cmbPlanta" formControlName="plantaId"
                    [control]="formCaptura.get('plantaId')" [label]="'Planta'" [id]="'plantaId'" [habilitar]="true" >
                    </app-lfsa-combo-box>
                  </div>
                  <div class="form-group form-control-sm col-md-3">
                    <app-lfsa-combo-box [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="listLineas" formControlName="lineaId"
                    [control]="formCaptura.get('lineaId')" [label]="'Linea'" [id]="'lineaId'" [habilitar]="true" >
                    </app-lfsa-combo-box>
                  </div>
                  <div class="form-group form-control-sm col-md-3">
                    <label for="control">Usuario</label>
                    <input class="form-control" formControlName="creadoPor" id="creadoPor" name="creadoPor" type="text" readonly/>
                  </div>  

                  <div class="d-grid gap-2 d-md-block">
                    <button type="button" (click)="getPesajeInfo()"   class="btn btn-primary "> <i aria-hidden="true" class="fas fa-sync"> </i> Capturar </button>
                    <button type="submit" (click)="saveCapturaPeso()" class="btn btn-success " [disabled]="formCaptura.invalid" > <i aria-hidden="true" class="fa fa-save"> </i> Guardar Captura
                    </button>
                  </div>
                </form>
                <br>
                <app-lfsa-gh-area *ngIf="listDataGrafico.length > 0"
                  [data]="listDataGrafico" 
                  [titulo]="'Pesos últimas 8 horas'">
                </app-lfsa-gh-area>
                
            </div>
            <!-- FIN BLOQUE -->
        </div>

      </div>
    </div>
  </ng-template>
</div>

<!-- MODAL PARA CAMBIAR LAS PLANTAS DE TRABAJO -->
  <app-lfsa-modal [classModal]="'Modal'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'"
    [titulo]="'Cambiar Planta de Trabajo'" [innTemplate]="abrirModalPopUp" >
  </app-lfsa-modal>

  <ng-template #abrirModalPopUp>
    <div class="container-fluid">
      <form [formGroup]="formPlanta" novalidate class="row form-group" mat-dialog-content>
        <div class="form-group col">
          <p>Seleccione la planta con la que se va a trabajar la captura de pesos</p>
          <!-- (change)="getLineaPlanta()"  -->
          <app-lfsa-combo-box 
            [opcion]="'nombre'" [idOpcion]="'plantaId'" [comboBox]="cmbPlanta" formControlName="plantaId"
            [control]="formPlanta.get('plantaId')" [label]="'Planta'" [id]="'plantaId'" >
          </app-lfsa-combo-box>
        </div>
        <app-lfsa-botones-formulario class="row"
          (devolverAccion)="acciones( $event )"
          [formularioValido]="formPlanta.invalid" 
          [loading]="loading" 
          [textBoton]="'Cargar'" >
        </app-lfsa-botones-formulario>
      </form>
    </div>
  </ng-template>
<!-- END MODAL -->